import { CommonModule } from '@angular/common';
import { GenerationLoaderComponent } from '@games/menar/shared/components/generation-loader/generation-loader.component';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { GamesSharedModule } from '@games/games-shared/games-shared.module';
import { GameCountdownComponent } from '@games/shared/game-countdown/game-countdown.component';
import { GameButtonComponent } from '@new-core/components/buttons-game/game-button/game-button.component';
import { GameInputComponent } from '@new-core/components/inputs-gi/game-input/game-input.component';
import { TranslateModule } from '@ngx-translate/core';
import {
  ButtonModule,
  DefaultImageModule,
  FitTextModule,
  FormFieldModule,
  TimerModule,
} from '@shared/components/games';
import { AnswerResultFormModule } from '../../../../new-core/components/game-forms/answer-result-form/answer-result-form.module';
import { CalculatorModule } from '@shared/components/games/calculator/calculator.module';
import { ResultFormBgModule } from '../../../../new-core/components/game-forms/result-form-bg/result-form-bg.module';
import { MentalControllerComponent } from './mental-controller/mental-controller.component';
import { MentalCorrectAnswerPreviewComponent } from './mental-preview/mental-answer-preview/mental-answer-preview.component';
import { MentalExamplePreviewComponent } from './mental-preview/mental-example-preview/mental-example-preview.component';
import { MentalParametersPreviewComponent } from './mental-preview/mental-parameters-preview/mental-parameters-preview.component';
import { MentalUserAnswerPreviewComponent } from './mental-preview/mental-user-answer-preview/mental-user-answer-preview.component';
import { MentalSettingsComponent } from './mental-settings/mental-settings.component';
import { AnswerEntryFormComponent } from '@new-core/components/inputs-gi/answer-entry-form/answer-entry-form.component';
import { CalculatorLayoutComponent } from '@shared/components/games/input-layouts/calculator-layout/calculator-layout.component';

@NgModule({
  declarations: [
    MentalControllerComponent,
    MentalSettingsComponent,
    MentalCorrectAnswerPreviewComponent,
    MentalExamplePreviewComponent,
    MentalParametersPreviewComponent,
    MentalUserAnswerPreviewComponent,
  ],
  exports: [
    MentalControllerComponent,
    MentalSettingsComponent,
    MentalCorrectAnswerPreviewComponent,
    MentalExamplePreviewComponent,
    MentalParametersPreviewComponent,
    MentalUserAnswerPreviewComponent,
  ],
  imports: [
    GenerationLoaderComponent,
    CommonModule,
    TranslateModule,
    FormsModule,
    ReactiveFormsModule,
    DefaultImageModule,
    CalculatorModule,
    FormFieldModule,
    FitTextModule,
    ButtonModule,
    TimerModule,
    GameInputComponent,
    GameButtonComponent,
    AnswerResultFormModule,
    ResultFormBgModule,
    GamesSharedModule,
    GameCountdownComponent,
    AnswerEntryFormComponent,
    CalculatorLayoutComponent,
  ],
})
export class MentalModule {}
